export default "__VITE_ASSET__GHlIRKRC__"